export function nl2br (str, replaceMode, isXhtml) {
  const breakTag = (isXhtml) ? '<br />' : '<br>'
  const replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr)
}
